import { css } from '@emotion/react';
import CorgixInput from '@veeva/corgix/input';
import { useContext } from 'react';
import Link from '../../components/Link';
import VerifyCodeFormContext from './VerifyCodeFormContext';
import InputKeys from './InputKeys';
import getTargetAttribute from '../../services/getTargetAttribute';

const VerifyCodeFormMobile = () => {
    const {
        inputLabel,
        inputRefs,
        onInputChange,
        onKeyDown,
        values,
        error,
        showResendClicked,
        codeSentLabel,
        onCodeResend,
        linkLabel,
        inputsDisabled,
        resendDisabled,
    } = useContext(VerifyCodeFormContext);

    let resendLink;
    if (showResendClicked) {
        resendLink = (
            <span
                css={({ grayLightest }) => css`
                    color: ${grayLightest};
                    font-size: 1.5rem;
                    margin-bottom: 3.333rem;
                `}
            >
                {codeSentLabel}
            </span>
        );
    } else {
        resendLink = (
            <Link
                css={({ grayLightest }) => [
                    css`
                        font-size: 1.5rem;
                        margin-bottom: 3.333rem;
                    `,
                    resendDisabled &&
                        css`
                            color: ${grayLightest};

                            &:hover,
                            &:active {
                                color: ${grayLightest};
                            }
                        `,
                ]}
                onClick={onCodeResend}
                disabled={resendDisabled}
                role="button"
                data-target={getTargetAttribute('resend-code-link')}
            >
                {linkLabel}
            </Link>
        );
    }

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                column-gap: 1.667rem;
                align-items: center;
            `}
        >
            <span
                css={css`
                    font-size: 14px;
                    font-weight: bold;
                    margin-bottom: 1rem;
                `}
            >
                {inputLabel}
            </span>
            <div
                css={css`
                    display: flex;
                    gap: 1rem;
                `}
            >
                {InputKeys.map((key, index) => (
                    <CorgixInput
                        css={css`
                            height: 3.333rem;
                            width: 3.333rem;
                            padding: 0;

                            input {
                                text-align: center;
                                font-size: 2.667rem;
                                border-radius: 8px;
                                width: 100%;
                            }
                        `}
                        key={key}
                        inputRef={(ref) => {
                            inputRefs.current[index] = ref;
                        }}
                        onChange={(e) => onInputChange(e, index)}
                        value={values[index]}
                        onKeyDown={(e) => onKeyDown(e, index)}
                        error={!!error}
                        disabled={inputsDisabled}
                        data-target={getTargetAttribute('code-input')}
                        type="text"
                        pattern="\d*"
                        inputmode="numeric"
                    />
                ))}
            </div>
            <span
                css={({ veevaIdErrorLabelBufferHeight, redDefault }) => css`
                    height: ${veevaIdErrorLabelBufferHeight};
                    margin: 0.333rem 0 0;
                    color: ${redDefault};
                    font-size: 1rem;
                `}
            >
                {error}
            </span>
            {resendLink}
        </div>
    );
};

export default VerifyCodeFormMobile;
